import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { selectVehicleOwnerOwnerData } from "../vehicleOwner.selectors";
import { setOwnerType } from "../vehicleOwner.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.VEHICLE_OWNER_OWNER,
  selector: selectVehicleOwnerOwnerData,
  content: [
    {
      sections: [
        {
          id: "vehicle-owner-owner-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.OWNER_TYPE,
              required: true,
              label:
                "Kto jest właścicielem pojazdu zgodnie z dowodem rejestracyjnym?",
              onChange: setOwnerType,
              items: [
                {
                  label: "osoba fizyczna",
                  value: "person",
                },
                {
                  label: "firma",
                  value: "company",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
